export default __webpack_public_path__ + "static/media/Placeholder-image.c18304f3.svg";